<template>
	<div class="movie-hall page">
		<van-nav-bar title="" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#e6b98a" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="banner">
			<van-swipe :autoplay="3000" lazy-render :show-indicators="false">
			  <van-swipe-item v-for="image in data.gatherimg" :key="image">
			    <img :src="domain + image" style="width: 100%;height: 100%;"/>
			  </van-swipe-item>
			</van-swipe>
		</div>
		<div class="notice-bar">
			<div class="wrapper">
				<img src="data:image/png;base64,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" alt="" class="newmovie-notice-icon">
				<div class="notice">
					{{data.typelabel}}
				</div>
				<div class="gonggao-div newmovie-notice-icon"><span>公告</span></div>
			</div>
		</div>
		<div class="detail-body">
			<div>
				<span>Id: {{data.itemid}}</span>
				<span>开卡可见</span>
			</div>
			<div>
				<div>
					<span>金标演示站打分</span>
					<span>{{data.grade}}</span>
					<span>美女颜值</span>
				</div>
				<div>
					<span>详细地址：已隐藏 联系小蜜开卡可见</span>
					<span>联系方式：已隐藏 联系小蜜开卡可见</span>
				</div>
			</div>
			<div>
				<ul>
					<li>
						<img src="data:image/png;base64,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" alt="">
						<span>基本信息 {{data.age}}岁,身高 {{data.height}}</span>
					</li>
					<li>
						<img src="data:image/png;base64,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" alt="">
						<span>所在地区 {{data.region}}</span>
					</li>
					<li>
						<img src="data:image/png;base64,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" alt="">
						<span>服务项目 激活可见</span>
					</li>
					<li>
						<span>祝金标演示站的会员们，天天约得美娇娘，夜夜都能当新郎！</span>
					</li>
				</ul>
			</div>
			<img class="body-img" :src="domain + data.gatherimg[0]" alt="">
			<img class="body-img" :src="domain + data.gatherimg[1]" alt="">
			<img class="body-img" :src="domain + data.gatherimg[2]" alt="">
			<div class="btn-div" @click="xfts()">立即约她</div>
		</div>
	</div>
</template>

<script>
// import { Toast } from 'vant';
export default {
	data() {
		return {
			data:'',
			domain: this.serviceUrl,
		};
	},
	methods: {
		back() {
			return window.history.back();
		},
		xfts() {
		  this.$toast("请联系专属客服接待");
		},
		getUrlParam() {
			let geturl = window.location.href;
			let getqyinfo = geturl.split('?')[1];
			let getqys = getqyinfo.split('&');
			let obj = {}; //创建空对象，接收截取的参数
			for (let i = 0; i < getqys.length; i++) {
				let item = getqys[i].split('=');
				let key = item[0];
				let value = item[1];
				obj[key] = value;
			}
			this.$http({
				method: 'get',
				url: 'getindexdata',
				data: { id: obj.id }
			}).then(res => {
				this.data = res.data;
			});
		}
	},
	created() {
		if (!localStorage.getItem('token')) {
			this.$router.push({ path: '/Login' });
		} else {
			this.getUrlParam();
		}
	}
};
</script>

<style lang="less" scoped>
.page {
	position: absolute !important;
	top: 0;
	left: 0;
	right: 0;
	background-color: #16151b;
	// height: 100%;
}
.nav-bar {
	/* background: linear-gradient(
      90deg,#7e5678,#e6c3a1); */
	height: 100px;
	background-color: #16151b;
	position: fixed;
}
.van-nav-bar {
	line-height: 50px;
}

::v-deep .van-nav-bar__title {
	max-width: 60%;
	margin: 0 auto;
	color: #f3c7a2;
	font-size: 35px;
}
::v-deep .van-nav-bar__content {
	height: 100px;
}
::v-deep .van-swipe{
	height: 31.6875rem;
}
.notice-bar {
    padding: 0 0.625rem;
    background-color: transparent;
    border: .008rem solid #e6b98a;
    border-radius: 0.3125rem;
    height: 2.0625rem;
    margin: 0.625rem 0.625rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.notice-bar .wrapper {
    display: flex;
    flex: 1;
    align-items: center;
}
.notice-bar .wrapper img {
    height: 1.625rem;
}
.notice-bar .wrapper .notice {
    margin-left: .26667rem;
    flex: 1;
    height: 1.9375rem;
    overflow: hidden;
	color: #faebd7;
	line-height: 1.9375rem;
	text-align: center;
}
.notice-bar .wrapper .gonggao-div {
    height: 1.25rem;
    width: 4.875rem;
    background-image: url(data:image/png;base64,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);
    line-height: 1.25rem;
    text-align: center;
}
.notice-bar .wrapper .gonggao-div span {
    font-size: .32rem;
    color: #533921;
    margin-right: -.4rem;
}
.detail-body {
    width: 95%;
    margin: 0 auto;
}
.detail-body>div:first-child {
    height: 2.5625rem;
    margin: 0.625rem 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
}
.detail-body>div:first-child span {
    font-size: 0.9375rem;
}
.detail-body span {
    color: #fff;
}
.detail-body>div:nth-child(2) {
    border: 0.0625rem solid #7e6a56;
    height: 5.1875rem;
    margin-bottom: 0.625rem;
    border-radius: 0.3125rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
.detail-body>div:nth-child(3) {
    border: 0.0625rem solid #7e6a56;
    height: 11rem;
    border-radius: 0.3125rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.625rem;
    margin-bottom: 0.625rem;
}
.detail-body>div:nth-child(2)>div:first-child {
    width: 6.5rem;
}
.detail-body>div:nth-child(2)>div {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.detail-body>div:nth-child(2)>div span {
    font-size: 0.875rem;
}
.detail-body>div:nth-child(2)>div:first-child>span:nth-child(2) {
    color: #f3c7a2;
    font-size: 1.25rem;
    font-weight: 700;
}
.detail-body>div:nth-child(2)>div:nth-child(2) {
    width: 16.25rem;
}
.detail-body>div:nth-child(3) ul li {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 1.9375rem;
}
.detail-body>div:nth-child(3) ul li img {
    height: 1.125rem;
    margin-right: .13333rem;
}
.detail-body>div:nth-child(3) ul li span {
    font-size: 0.875rem;
}
.detail-body>div:nth-child(3) ul>li:nth-child(3) {
    height: 2.5625rem;
    border-bottom: 0.125rem solid #7e6a56;
}
.detail-body>div:nth-child(3) ul>li:nth-child(4) {
    margin-top: .13333rem;
}
.detail-body .body-img {
    width: 100%;
}
.detail-body .btn-div {
    width: 70%;
    height: 2.3125rem;
    background: linear-gradient(#fde3ca,#e7b486);
    text-align: center;
    margin: 0.625rem auto;
    line-height: 2.3125rem;
    color: #333;
    border-radius: 2.3125rem;
    font-size: 0.9375rem;
}
</style>
